// extracted by mini-css-extract-plugin
module.exports = {"hoverAnim":"emoji_hoverAnim__3Rzns","faded":"emoji_faded__iBUf8"};